// All mocked data for AMS (Adways Marketing Solution) — to be replaced by backend later.

export const BRAND = {
  name: "Adways Marketing Solution",
  short: "AMS",
  tagline: "WE BUILD BRANDS ACROSS INDIA",
  subTagline: "Out-of-Home Advertising. End to End. Pan-India.",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_c295a466-c129-4860-8e17-0fcbe8e8bcb2/artifacts/82f2xs5g_PHOTO-2026-05-14-19-47-28.jpg",
  foundersPhoto:
    "https://customer-assets.emergentagent.com/job_c295a466-c129-4860-8e17-0fcbe8e8bcb2/artifacts/7jy1th4u_PHOTO-2026-05-14-19-51-57.jpg",
  email: "adwaysworldwide@gmail.com",
  phones: ["+91 89297 39310", "+91 98715 50711"],
  phone: "+91 89297 39310",
  hq: "Pan India · Headquartered in Faridabad",
  address: "D1, T-4, RPS 12th Avenue, Main Mathura Road, Faridabad",
  addressLabel: "Corporate Office",
  instagram: "@adwaysmarketing",
  instagramUrl: "https://www.instagram.com/adwaysmarketing",
};

export const HERO_IMAGES = [
  "https://customer-assets.emergentagent.com/job_adways-campaign/artifacts/xwi94ubs_PHOTO-2026-05-15-18-37-20.jpg",
  "https://customer-assets.emergentagent.com/job_adways-campaign/artifacts/isobzyy7_PHOTO-2026-05-15-18-47-56.jpg",
  "https://customer-assets.emergentagent.com/job_adways-campaign/artifacts/edcpria6_PHOTO-2026-05-15-18-47-57%202.jpg",
  "https://customer-assets.emergentagent.com/job_adways-campaign/artifacts/qmbmqxgq_PHOTO-2026-05-15-18-47-56%202.jpg",
];

export const NAV_LINKS = [
  { label: "Who We Are", to: "/about" },
  { label: "Media", to: "/media" },
  { label: "Markets", to: "/markets" },
  { label: "Creative", to: "/creative" },
  { label: "Contact", to: "/contact" },
];

export const STATS = [
  { value: "28+", label: "Cities", source: "Pan-India network, 2025" },
  { value: "4,200+", label: "Canvases", source: "Across India, 2025" },
  { value: "850M+", label: "Weekly Impressions", source: "AMS Insights, 2025" },
  { value: "120+", label: "Brands Served", source: "Since inception" },
];

export const SERVICES = [
  {
    title: "Billboards & Hoardings",
    blurb:
      "Premium large-format media on India's busiest streets, highways and skylines — strategically curated for impact and recall.",
    image:
      "https://customer-assets.emergentagent.com/job_adways-campaign/artifacts/6f1hto8z_PHOTO-2026-05-18-18-48-43.jpg",
  },
  {
    title: "Transit Advertising",
    blurb:
      "Buses, autos, metro stations and rail. We turn movement into market reach across every major Indian city.",
    image:
      "https://customer-assets.emergentagent.com/job_adways-campaign/artifacts/isobzyy7_PHOTO-2026-05-15-18-47-56.jpg",
  },
  {
    title: "Mall & Retail Media",
    blurb:
      "Reach high-intent shoppers at the point of purchase across India's leading malls and high-street retail belts.",
    image:
      "https://images.unsplash.com/photo-1716827173021-57a1b5e85580?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "Creative & Production",
    blurb:
      "In-house creative studio — concepts, design, fabrication and installation, end to end.",
    image:
      "https://customer-assets.emergentagent.com/job_adways-campaign/artifacts/liyfd7pj_PHOTO-2026-05-18-18-20-27.jpg",
  },
];

export const CASE_STUDIES = [
  {
    brand: "MVN Infrastructure",
    city: "Gurugram · Delhi NCR",
    type: "Highway Hoardings",
    image:
      "https://customer-assets.emergentagent.com/job_adways-campaign/artifacts/xwi94ubs_PHOTO-2026-05-15-18-37-20.jpg",
  },
  {
    brand: "Amrita Hospital",
    city: "Sector 28, Faridabad",
    type: "City Billboards",
    image:
      "https://customer-assets.emergentagent.com/job_adways-campaign/artifacts/liyfd7pj_PHOTO-2026-05-18-18-20-27.jpg",
  },
  {
    brand: "Yatharth Hospital",
    city: "Sector 20, Faridabad",
    type: "Metro Station Media",
    image:
      "https://customer-assets.emergentagent.com/job_adways-campaign/artifacts/isobzyy7_PHOTO-2026-05-15-18-47-56.jpg",
  },
  {
    brand: "Manohar Lal Jewellers",
    city: "NIT, Faridabad",
    type: "Premium Billboards",
    image:
      "https://customer-assets.emergentagent.com/job_adways-campaign/artifacts/xhsqq9xh_PHOTO-2026-05-18-18-48-21.jpg",
  },
  {
    brand: "Kunal Jewellers",
    city: "Gurugram · Faridabad",
    type: "Mall & Premium OOH",
    image:
      "https://customer-assets.emergentagent.com/job_adways-campaign/artifacts/6f1hto8z_PHOTO-2026-05-18-18-48-43.jpg",
  },
  {
    brand: "Skoda India",
    city: "Faridabad",
    type: "Highway & Urban",
    image:
      "https://customer-assets.emergentagent.com/job_adways-campaign/artifacts/ryus2bdo_IMG_9698.jpg",
  },
  {
    brand: "Stanmaxx",
    city: "Delhi NCR",
    type: "Transit Advertising",
    image:
      "https://images.unsplash.com/photo-1565465132953-10eed3b3cf56?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    brand: "H&M India",
    city: "Pan-India",
    type: "Mall & Retail Media",
    image:
      "https://images.unsplash.com/photo-1716827173021-57a1b5e85580?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    brand: "Snitch",
    city: "Mumbai · Bengaluru",
    type: "Urban Billboards",
    image:
      "https://images.unsplash.com/photo-1704281008107-8658de07715d?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "AMS turned our launch into a city-wide conversation. The execution across Delhi NCR was flawless.",
    name: "Marketing Head",
    role: "MVN Infrastructure",
  },
  {
    quote:
      "From strategy to installation, every detail was handled. Easily the most reliable OOH partner we've worked with.",
    name: "Brand Team",
    role: "Amrita Hospital",
  },
  {
    quote:
      "Bold creative, premium sites, real measurable lift. AMS is our default for every national campaign.",
    name: "Brand Marketing",
    role: "Skoda India",
  },
];

export const FOUNDERS = [
  {
    name: "Sidhanth Bhutani",
    role: "Co-Founder",
    bio: "Mr. Sidhanth Bhutani co-founded the company with a vision to transform outdoor advertising into immersive brand experiences that command attention and create lasting impact. Starting from scratch at a young age, he built the business through ambition, strategic execution, and a deep understanding of branding and visibility.\n\nToday, under his leadership, the company has grown into a rapidly expanding outdoor media network known for premium locations, impactful campaigns, and innovative branding solutions across Delhi NCR and beyond.",
  },
  {
    name: "Om Malhotra",
    role: "Co-Founder",
    bio: "Mr. Om Malhotra co-founded the company with a shared vision of building a next-generation outdoor media network focused on scale, innovation, and impactful brand visibility. With a strong understanding of operations, execution, and client relations, he has played a key role in expanding the company's presence across premium advertising markets.\n\nKnown for his strategic approach and commitment to delivering high-impact campaigns, Om has been instrumental in building strong industry relationships and ensuring seamless execution across projects. Together, the founders continue to drive the company toward becoming a leading force in immersive outdoor advertising.",
  },
];
